import type { HttpClient } from '../http/HttpClient.ts';

export interface DescriptionVersion {
  id: string;
  createdAt: string;
  authors: { id: string; name: string }[];
  length: number;
}

/** A description's saved versions: list, read, restore. */
export class DescriptionsApi {
  readonly #http: HttpClient;

  constructor(http: HttpClient) {
    this.#http = http;
  }

  #base(org: string, key: string, n: number): string {
    return `/orgs/${encodeURIComponent(org)}/projects/${encodeURIComponent(key)}/items/${n}/versions`;
  }

  versions(org: string, key: string, n: number): Promise<{ versions: DescriptionVersion[] }> {
    return this.#http.get(this.#base(org, key, n));
  }

  version(org: string, key: string, n: number, id: string): Promise<{ markdown: string }> {
    return this.#http.get(`${this.#base(org, key, n)}/${encodeURIComponent(id)}`);
  }

  restore(org: string, key: string, n: number, id: string): Promise<void> {
    return this.#http.post(`${this.#base(org, key, n)}/${encodeURIComponent(id)}/restore`);
  }
}
